import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  TextField,
} from "@mui/material";
import Field from "../Field/Fi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CategoriesHeavyMachinery } from "../../../tempData/data";
import Button from "../Button/Button";

function SearchHomeModal({ open, toggleDrawer }) {
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");

  const [filteredData, setFilteredData] = React.useState(
    CategoriesHeavyMachinery
  );

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setSearchValue(searchWord);
    const newFilter = CategoriesHeavyMachinery.filter((value) => {
      return value.toLowerCase().includes(searchWord.toLowerCase());
    });
    if (searchWord === "") {
      setFilteredData([...CategoriesHeavyMachinery]);
    } else {
      setFilteredData(newFilter);
    }
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          minHeight: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          width: "100%",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          padding: "16px",
        }}
      >
        <TextField
          value={searchValue}
          onChange={handleFilter}
          label="Search Machinery"
          InputProps={{
            startAdornment: (
              <ArrowBackIcon
                sx={{
                  width: "24px",
                  height: "24px",
                  color: "#255CCE",
                }}
                onClick={toggleDrawer(false)}
              />
            ),
            sx: {
              height: "43.91px",
            },
          }}
        />
        <Typography
          variant="body2"
          sx={{
            marginTop: "10px",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#808080",
          }}
        >
          Search by category, make, mode, year or keyword.
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "scroll",
            marginTop: "8px",
            columnGap: "8px",
          }}
        >
          {selectedOptions.map((opt) => {
            return (
              <Button
                variant="outlined"
                bgColor="#255CCE1A"
                outColor="#255CCE"
                typoVariant="body1"
                typoSize="16px"
                txColor="text.primary"
                fontWeight="400"
                sx={{
                  minWidth: "fit-content",
                  padding: "0px 8px!important",
                  height: "36px !important",
                }}
                endIcon={
                  <CloseIcon
                    onClick={() => {
                      const newArr = selectedOptions.filter((so) => {
                        return so !== opt;
                      });
                      setSelectedOptions(newArr);
                    }}
                    sx={{ width: "16px", height: "16px", color: "#1f1f1f" }}
                  />
                }
              >
                {opt}
              </Button>
            );
          })}
        </Box>
        <Box sx={{ marginTop: "24px" }}>
          <List sx={{ justifyContent: "start" }}>
            <ListSubheader
              sx={{
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "16px",
                textAlign: "start",
                textTransform: "uppercase",
                padding: "0px",
                paddingBottom: "16px",
              }}
            >
              Trending
            </ListSubheader>
            {filteredData.map((cat) => {
              return (
                <ListItem sx={{ paddingBottom: "16px" }} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedOptions([...selectedOptions, cat]);
                    }}
                    sx={{ padding: "0px" }}
                  >
                    <ListItemText
                      primary={cat}
                      primaryTypographyProps={{
                        variant: "body1",
                        sx: {
                          fontSize: "16px",
                          lineHeight: "24px",
                          fontWeight: "400",
                        },
                      }}
                      sx={{ padding: "0px" }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Box>
      {selectedOptions.length !== 0 && (
        <Box
          sx={{
            height: 80,
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            padding: "16px",
            background: "#fff",
            display: "flex",
            alignItem: "center",
            justifyContent: "center",
            position: "sticky",
            width: "100%",
            bottom: "0%",
          }}
        >
          <Button
            typoVariant="subtitle1"
            typoSize="16px"
            fontWeight="600"
            variant="standard"
            size="small"
            height="48px"
            bgColor="#F9D548"
            sx={{ width: "100%", height: "48px" }}
          >
            Show 20 Machinery
          </Button>
        </Box>
      )}
    </SwipeableDrawer>
  );
}

export default SearchHomeModal;
